<script lang="ts">
  import { Drawer, Button } from "flowbite-svelte";
  import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
  import { faTimes } from "@fortawesome/free-solid-svg-icons";
  import { sineIn } from "svelte/easing";
  import FilesUpload from "../objects/FilesUpload.svelte";

  export let hidden = true;
  export let project_id: string;

  let activateClickOutside = false;
  let transitionParams = {
    x: -280,
    duration: 200,
    easing: sineIn
  };

  function handleClose() {
    hidden = true;
  }
</script>

<Drawer id="files-upload-drawer" {activateClickOutside} class="object-drawer" transitionType="fly" {transitionParams} placement="left" backdrop={true} bind:hidden>
  <div class="drawer-header">
    <div class="drawer-title-container">
      <h2>Project Documents Upload</h2>
    </div>
    <Button class="drawer-header-button" on:click={handleClose}>
      <FontAwesomeIcon icon={faTimes} />
    </Button>
  </div>

  <FilesUpload {project_id} on:close={handleClose} />
</Drawer> 